import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandTvinna(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <mask
        style={{ maskType: 'alpha' }}
        id="tvinna-a"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" rx="2" fill="#C4C4C4" />
      </mask>
      <g mask="url(#tvinna-a)">
        <path fill="#C63825" d="M0 0h24v24H0z" />
        <path fill="#C63825" d="M0 0h24v24H0z" />
        <path fill="#fff" d="M8.4 6.6h7.2V9H8.4zM10.8 9h2.4v8.4h-2.4z" />
      </g>
    </BaseIcon>
  );
}
